export default class PolicyEnforcementGrid {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/healthplan/policyEnforcementRules";
  }

  getActivePolicyGrid(params) {
    return this.client.get(`/healthplan/${params.healthPlanName}/policy`, {
      params: { lineOfBusinessKeys: params.lineOfBusinessKeys },
    });
  }

  // getExclusionRulesData
  getExclusionRules(params) {
    return this.client.get(`${this.resourceUrl}/exclusionPage`, params);
  }

  // getPolicies
  getExclusionPolicyKeys(params) {
    return this.client.get(`${this.resourceUrl}/exclusionPolicyKeys`, params);
  }

  // Save exclusion rule edits
  saveExclusionRules(ruleSetKey, payload) {
    return this.client.post(
      `${this.resourceUrl}/saveExclusionRules/${ruleSetKey}`,
      payload
    );
  }

  getAllLineOfBusinessConfig(hpKey) {
    return this.client.get(`${this.resourceUrl}/allLobConfigs/${hpKey}`);
  }

  getAllAdoptionOptions() {
    return this.client.get(`${this.resourceUrl}/allAdoptionOptions`);
  }

  getPolicyLobConfig(hpKey, policyKey) {
    return this.client.get(
      `${this.resourceUrl}/policyLobConfig/${hpKey}/${policyKey}`
    );
  }

  getPoliciesForAdoptionDecision(hpKey, quarter, year) {
    return this.client.get(`${this.resourceUrl}/cabPolicies`, {
      params: { hpKey, quarter, year },
    });
  }

  saveAdoptionDecisions(completedPolicies, isBreakFix = false) {
    return this.client.post(
      `${this.resourceUrl}/saveAdoptionDecisions?isBreakFix=${isBreakFix}`,
      completedPolicies
    );
  }

  applyGlobalBreakFix(policyKey, effectiveDate) {
    return this.client.post(
      `/policyRules/active/globalBreakFix/${policyKey}`,
      null,
      { params: { effectiveDate } } // "YYYY-MM-DD"
    );
  }

  genericBulkAction(hpKey, requestData) {
    return this.client.post(
      `/policyRules/bulkUpdate/genericAction/${hpKey}`,
      requestData
    );
  }

  getBulkActionWorkflow() {
    return this.client.get(`/policyRules/active/bulkActionWorkflow`);
  }
}
